module.exports = __webpack_public_path__ + "static/greycliffcf-regularoblique-webfont-20007fef893a0da32a2ce934affd9f9c.woff";